export interface IMovieActivity {
	edi?: string;
	streamingId?: string;
	movieStats?: IMovieStats;

	movieUserInteraction?: IUserDataForMovie;
}

export interface IMovieStats {
	watchlistCount: number;
	favouriteCount: number;
	reviewCount: number;
	ratingCount: number;
	ratingAverage: number;
}

export interface IUserDataForMovie {
	watchlisted: boolean;
	favourite: boolean;
	review: string;

	reviewId: number | undefined;
	rating: number | undefined;

	reportedReviews: number[];
}


export const emptyMovieActivity: IMovieActivity = {
	movieStats: {
		watchlistCount: 0,
		favouriteCount: 0,
		reviewCount: 0,
		ratingCount: 0,
		ratingAverage: 0
	},
	movieUserInteraction: {
		watchlisted: false,
		favourite: false,
		review: "",
		reportedReviews: [],
		reviewId: undefined,
		rating: undefined
	}
};
